module.exports = __webpack_public_path__ + "img/_3.5af2bd6d.png";